import React from 'react';
import { Typography, WebsitePrimaryButton } from '@dev/ee-components';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from '@material-ui/core';
import { getAccountStore } from '@api/store/account/actions';
import { useIntercom } from 'react-use-intercom';
import styled from 'styled-components';

const DescriptionWrapper = styled.div`
    max-width: 580px;
`;

export const useSuccessConfig = () => {
    const { t } = useTranslation();
    const { show } = useIntercom() || {};

    const account = useSelector(getAccountStore);
    const name = account?.Profile?.FirstName;

    const clickReload = () => {
        window.location.reload();
    };

    const launchIntercom = () => {
        show();
    };

    return {
        title: (
            <Typography variant="h1" align="center">
                {t('welcometoee')}
                {name ? `, ${name}!` : '!'}
            </Typography>
        ),
        description: (
            <DescriptionWrapper>
                <Typography variant="body1" align="center">
                    <Trans
                        i18nKey={'weappreciateyourinput'}
                        components={{
                            url: <Link onClick={launchIntercom} />,
                        }}
                        defaults={'weappreciateyourinput'}
                    />
                </Typography>
            </DescriptionWrapper>
        ),
        ctaButton: <WebsitePrimaryButton onClick={clickReload} text={t('letsstart')} />,
    };
};
